module.exports = __webpack_public_path__ + "img/west-winter-1920x550.707221c5.jpg";